<div>
	<p>When deleting this Group Action, do you want to permanently remove the incident from each student it has been assigned to?</p>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onYes()">Yes</button>
	<button class="btn btn-primary" (click)="onNo()">No</button>
	<button class="btn btn-primary" (click)="onCancel()">Cancel</button>
</div>
